import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  createConfigSlice,
  createCallbackSlice,
  createInputHistorySlice,
  createSessionSlice,
  createUiSlice,
  createOutputSlice,
} from "./slices";
const useCommandFlowStore = create(
  persist(
    (set, get) => ({
      // Combine all slices
      ...createConfigSlice(set, get),
      ...createCallbackSlice(set, get),
      ...createInputHistorySlice(set, get),
      ...createSessionSlice(set, get),
      ...createUiSlice(set, get),
      ...createOutputSlice(set, get),
    }),
    {
      name: "command-flow-storage", // unique name
      partialize: (state) => ({
        // theme is NOT persisted - always uses defaultTheme from code
        history: state.history,
        promptLabel: state.promptLabel, // Persist promptLabel
        outputDelay: state.outputDelay, // Persist outputDelay
      }), // only persist history, promptLabel, and outputDelay
    }
  )
);

export default useCommandFlowStore;
